export default __webpack_public_path__ + "static/media/single-1.5ee1c74c.jpg";